import { initNotificationList } from './list.js';
import { setupMarkAllReadEvents } from './handlers.js';

/**
 * Entry point for Notifications module
 */
export function initNotifications() {
	initNotificationList();
	setupMarkAllReadEvents();
}
